(function(Forms, $, undefined) {
  var bindUIActions = function() {
    $('[data-mailchimp-form]').on('submit', function(e) {
      e.preventDefault();

      var $form = $(this);

      var newsletterSource = $form.attr('data-newsletter-source');

      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
        error: function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success: function(data) {
          let message = '<p>' + data.msg + '</p>';
          
          if ($((message)).find('a').length) {
            message = $((message)).find('a').addClass('text-link text-link--same').parent();
          }

          $form.find('[data-form-message]').html(message).slideDown();

          if (newsletterSource) {
            ga('send', {
              hitType: 'event',
              eventCategory: 'Newsletter',
              eventAction: 'Signup',
              eventLabel: newsletterSource,
            });
  
            // TRACK SEGMENT EVENT
            analytics.track('User Subscribed to Newsletter', {
              newsletterSource: newsletterSource,
            });
          }
        }
      });
    })
  }

  Forms.init = function() {
    bindUIActions(); 
  }

}(window.Forms = window.Forms || {}, jQuery));